import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription, Observable } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { AlertService } from 'src/app/main/alert.service';
import { DataSharingService } from 'src/app/main/data-sharing.service';
import { UrlPrefixes } from 'src/app/model/cms-btv-core/config-controller/config-url-prefix.model';
import { Catchup } from 'src/app/model/cms-vod-core/catchup-models/catchup-model';
import { ComingSoonContent } from 'src/app/model/coming-soon-content.model';
import { ContentPoster } from 'src/app/model/content-poster.model';
import { Content } from 'src/app/model/content.model';
import { PosterDefinition } from 'src/app/model/poster-definition.model';
import { CatchupService } from 'src/app/services/cms-vod-core/catchup-service/catchup.service';
import { CategoryService } from 'src/app/services/cms-vod-core/category-controller/category.service';
import { ComingSoonContentsService } from 'src/app/services/cms-vod-core/coming-soon-contents/coming-soon-contents.service';
import { ContentService } from 'src/app/services/cms-vod-core/contents-controller/content.service';
import { PosterDefinitionService } from 'src/app/services/cms-vod-core/poster-definition/poster-definition.service';
import * as PosterSetActions from 'src/app/utility/actions/posters-without-catchup.actions';
import { Utility } from 'src/app/utility/utility';
import { PosterService } from '../../../../services/cms-vod-core/poster-service-controller/poster.service';
import * as RefreshActions from 'src/app/utility/actions/refresh-state.actions';
import { RefreshManagerService, RefreshTarget } from 'src/app/main/RefreshManagerService';
import { BannerService } from '../../../../services/cms-vod-core/banner-service/banner-service';
import { BannerPosterDefinition } from 'src/app/model/cms-vod-core/banner-model/banner-poster-definition';

declare var $: any;

@Component({
  selector: 'app-vod-posters',
  templateUrl: './vod-posters.component.html',
  styleUrls: ['./vod-posters.component.css'],
})
export class VodPostersComponent implements OnInit, AfterViewInit, OnDestroy {
  contentId: number;
  catchupId: number;
  categoryId: number;
  epgProgramId: number;
  comingSoonContentId: number;
  content: any;
  posters: ContentPoster[];
  posterDefinitions: PosterDefinition[];
  selectedPosterDef: PosterDefinition;
  posterUrl: string = null;
  disableUpload: boolean = true;
  fileToUpload: File;
  deletablePoster: PosterDefinition;
  autoPosterCreation: boolean = false;
  isVisible: boolean;
  image: string;
  posterNumberArray: number[] = [];
  updateChilds: boolean = false;
  contentPosters: ContentPoster[];
  selectedPoster: ContentPoster;
  buttonLoading: boolean;
  contentUrlPrefixes: UrlPrefixes;
  subscription: Subscription;
  isLoading: boolean = false;
  categoryUrlPrefix: UrlPrefixes;
  postersWithoutCatchup: ContentPoster[] = [];
  allPosters: Observable<ContentPoster[]>;
  object: any;

  // Banner creation
  bannerSectionOpen: boolean = false;
  bannerForm: any = { name: '', isChild: false };
  bannerStartDateStr: string = '';
  bannerEndDateStr: string = '';
  bannerMinDateStr: string = '';
  bannerMaxDateStr: string = '';
  bannerPosterPreview: string = null;
  bannerPosterFile: File = null;
  bannerImageError: string = '';
  bannerError: string = '';
  bannerSuccess: string = '';
  bannerCreating: boolean = false;
  bannerPosterDefinition: BannerPosterDefinition = null;

  constructor(
    private comingSoonService: ComingSoonContentsService,
    private posterDefService: PosterDefinitionService,
    private categoryService: CategoryService,
    private dataSharing: DataSharingService,
    private contentService: ContentService,
    private catchupService: CatchupService,
    private posterService: PosterService,
    private alertService: AlertService,
    private bannerService: BannerService,
    private route: ActivatedRoute,
    public utility: Utility,
    private store: Store<AppState>,
    private refreshManager: RefreshManagerService,
    private renderer: Renderer2,
  ) {

    this.allPosters = this.store.select('posters');
  }

  ngOnInit(): void {
    this.contentId = this.route.snapshot.params['contentId'];
    this.catchupId = this.route.snapshot.params['catchupId'];
    this.categoryId = this.route.snapshot.params['categoryId'];
    this.epgProgramId = this.route.parent.snapshot.params['epgProgramId'];
    this.comingSoonContentId = this.route.snapshot.params['comingSoonContentId'];
    this.selectedPosterDef = new PosterDefinition();
    this.deletablePoster = new PosterDefinition();
    this.content = new Content();
    if (this.contentId) {
      this.getContentById();
      this.getContentPosters(this.contentId);
      this.getAllPosterDefinitions('Content');
    } else if (this.catchupId) {
      this.getCatchupById(this.catchupId);
      this.getAllPosterDefinitions('Content');
    } else if (this.categoryId) {
      this.getCategoryById(this.categoryId);
      this.getAllPosterDefinitions('Category');
    } else if (this.comingSoonContentId) {
      this.getComingSoonOfContentById(this.comingSoonContentId);
      this.getAllPosterDefinitions('Content');
    } else if (this.epgProgramId) {
      this.getAllPosterDefinitions('Content');
      this.allPosters.subscribe((data) => {
        data.forEach((def) => {
          this.object = def;
          this.posterNumberArray.push(def.posterDefinition.id);
        });
      });
      // Include program poster definition IDs as green (matched by size)
      if (this.dataSharing.programPosterDefinitionIds) {
        this.dataSharing.programPosterDefinitionIds.forEach((id) => {
          if (!this.posterNumberArray.includes(id)) {
            this.posterNumberArray.push(id);
          }
        });
      }
    } else {
      this.getAllPosterDefinitions('Content');
    }
  }

  ngAfterViewInit(): void {
    this.utility.openModal('posterList');
    if (this.contentId) {
      this.subscription = this.dataSharing.getContentUrlPrefix().subscribe((response) => {
        this.contentUrlPrefixes = response;
      });
    } else if (this.comingSoonContentId) {
      this.subscription = this.dataSharing.getComingSoonUrlPrefix().subscribe((response) => {
        this.contentUrlPrefixes = response;
      });
    } else if (this.catchupId) {
      this.subscription = this.dataSharing.getCatchupUrlPrefix().subscribe((response) => {
        this.contentUrlPrefixes = response;
      });
    } else if (this.categoryId) {
      this.subscription = this.dataSharing.getCategoryUrlPrefix().subscribe((response) => {
        this.contentUrlPrefixes = response;
      });
    } else if (this.epgProgramId) {
      this.contentUrlPrefixes = new UrlPrefixes('tempPosterUrl', localStorage.getItem('tempPosterUrl'));
    }
    $('posterUpload').on('hidden.bs.modal', () => {
      this.posterUrl = null;
      this.selectedPoster = null;
      this.selectedPosterDef = null;
      this.cleanupModalArtifacts();
    });
  }

  ngOnDestroy(): void {
    //this.store.dispatch(new RefreshActions.RefreshState(true));
    this.cleanupModalArtifacts();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.comingSoonContentId) {
      this.store.dispatch(new RefreshActions.RefreshState(true));
    }
  }
  //Get Content By ID
  getContentById(): void {
    this.content = new Content();
    this.contentService.getContentById(this.contentId).subscribe((response) => {
      this.content = response;
      this.posterNumberArray = [];
      this.object = response;
      for (let posterIterator = 0; posterIterator < this.content.posters.length; posterIterator++) {
        this.posterNumberArray.push(this.content.posters[posterIterator].posterDefinition.id);
        posterIterator;
      }
    });
  }
  // Get catchup by Id
  getCatchupById(catchupId?: number): void {
    this.content = new Catchup();
    this.catchupService.getCatchupById(catchupId).subscribe((response) => {
      this.content = response;
      this.posterNumberArray = [];
      this.object = response;
      this.posterSetter(this.object);
      this.posters = this.content.posters;
      for (const poster of this.content.posters) {
        this.posterNumberArray.push(poster.posterDefinition.id);
      }
    });
  }

  getCategoryById(categoryId: number): void {
    this.categoryService.getCategoryById(categoryId).subscribe((response) => {
      this.posters = response.posters;
      this.object = response;
      this.posterNumberArray = [];
      for (const key in this.posters) {
        if (Object.prototype.hasOwnProperty.call(this.posters, key)) {
          this.posterNumberArray.push(this.posters[key].posterDefinition.id);
        }
      }
    });
  }

  // Get ComingSoon Content by Id
  getComingSoonOfContentById(comingSoonContentId: number): void {
    this.content = new ComingSoonContent();
    this.comingSoonService.getComingSoonContentById(comingSoonContentId).subscribe((response) => {
      this.content = response;
      this.object = response;
      this.posters = response.posters;
      this.posterNumberArray = [];
      for (let posterI = 0; posterI < this.content.posters.length; posterI++) {
        this.posterNumberArray.push(this.content.posters[posterI].posterDefinition.id);
        posterI;
      }
    });
  }

  /** Gets All Poster Definition */
  getAllPosterDefinitions(type: string): void {
    this.posterDefService.getAllPosterDefinitions(type).subscribe((response) => {
      this.posterDefinitions = response;
    });
  }

  // Get Posters of content
  getContentPosters(contentId: number): void {
    try {
      this.contentService.getContentPosters(contentId).subscribe((response) => {
        this.posters = response;
      });
    } catch (error) { }
  }

  setPosterToUpload(posterToSet: PosterDefinition) {
    this.selectedPosterDef = posterToSet;
    this.selectedPoster = null;
    if (this.posters) {
      for (const poster of this.posters) {
        if (this.selectedPosterDef.id == poster.posterDefinition.id) {
          this.selectedPoster = poster;
        }
      }
    } else if (this.epgProgramId) {
      this.allPosters.subscribe((data) => {
        data.forEach((k) => {
          if (k.posterDefinition.id === posterToSet.id) {
            this.selectedPoster = k;
          }
        });
      });
    }
  }

  handleFileInput(event: any): void {
    $('#posterUpload').on('hidden.bs.modal', () => {
      this.fileToUpload = null;
      this.posterUrl = null;
      event.target.value = null;
    });

    if (event.target.files[0].size) {
      this.fileToUpload = event.target.files[0];
      const reader = new FileReader();
      const image = new Image();
      reader.readAsDataURL(this.fileToUpload);
      reader.onload = (e: any) => {
        image.src = e.target.result;
        this.posterUrl = image.src;
        image.onload = () => {
          this.validImage(image.width, image.height);
        };
      };
    } else {
      this.disableUpload = true;
      this.fileToUpload = null;
      this.posterUrl = null;
      this.selectedPoster = null;
      this.selectedPosterDef = null;
    }
  }

  // Image Validation
  validImage(width: number, height: number) {
    if (width != this.selectedPosterDef.width || height != this.selectedPosterDef.height) {
      this.alertService.warning(
        'Poster ' +
        this.selectedPosterDef.name +
        ' dimensions must be ; width: ' +
        this.selectedPosterDef.width +
        ', height: ' +
        this.selectedPosterDef.height,
      );
      this.disableUpload = true;
    } else {
      this.disableUpload = false;
    }
  }

  saveImage(): void {
    this.isLoading = true;
    this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
    if (this.contentId) {
      this.setContentPoster();
    } else if (this.categoryId) {
      this.setCategoryPoster();
    } else if (this.catchupId) {
      this.setCatchupPoster();
    } else if (this.comingSoonContentId) {
      this.setComingSoonContentPoster();
    } else {
      this.setPosterWithoutCatchup();
    }
  }

  // set poster without catchup id

  setPosterWithoutCatchup(): void {
    this.catchupService
      .setPosterWithoutCatchup(this.selectedPosterDef.id, this.autoPosterCreation, this.fileToUpload)
      .subscribe((response) => {
        for (const p of response) {
          this.posterNumberArray.push(p.posterDefinition.id);
          this.store.dispatch(new PosterSetActions.SetCatchupPoster(p));
        }
        //this.dataSharing.sendContentPosters(response);
        this.utility.closeModal('posterUpload');
      })
      .add((_) => {
        this.selectedPosterDef = new PosterDefinition();
        this.posterUrl = null;
        this.fileToUpload = null;
        this.isLoading = false;
      });
  }

  setContentPoster(): void {
    this.contentService
      .setPosterToContent(this.contentId, this.selectedPosterDef.id, this.autoPosterCreation, this.updateChilds, this.fileToUpload)
      .subscribe((_) => {
        this.getContentPosters(this.contentId);
        this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_DETAIL);
        this.getContentById();
        this.isLoading = false;
        this.utility.closeModal('posterUpload');
      })
      .add((_) => {
        this.selectedPosterDef = new PosterDefinition();
        this.posterUrl = null;
        this.fileToUpload = null;
        this.isLoading = false;
        this.utility.closeModal('posterUpload');
      });
  }

  setCategoryPoster(): void {
    this.isLoading = true;
    this.categoryService
      .setCategoryPoster(this.categoryId, this.selectedPosterDef.id, this.fileToUpload, this.autoPosterCreation)
      .subscribe((_) => {
        this.getCategoryById(this.categoryId);
        this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_DETAIL);
        this.isLoading = false;
        this.utility.closeModal('posterUpload');
      })
      .add((_) => {
        this.selectedPosterDef = new PosterDefinition();
        this.posterUrl = null;
        this.fileToUpload = null;
        this.isLoading = false;
      });
  }

  setCatchupPoster(): void {
    this.isLoading = true;
    this.catchupService
      .setCatchupPosters(this.catchupId, this.selectedPosterDef.id, this.autoPosterCreation, this.updateChilds, this.fileToUpload)
      .subscribe((_) => {
        this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_DETAIL);
        this.getCatchupById(this.catchupId);
        this.isLoading = false;
        this.utility.closeModal('posterUpload');
      })
      .add((_) => {
        this.selectedPosterDef = new PosterDefinition();
        this.posterUrl = null;
        this.fileToUpload = null;
        this.isLoading = false;
      });
  }

  setComingSoonContentPoster(): void {
    this.comingSoonService
      .setPosterToContent(this.content.id, this.selectedPosterDef.id, this.autoPosterCreation, this.fileToUpload)
      .subscribe((_) => {
        this.isLoading = false;
        this.store.dispatch(new RefreshActions.RefreshState(true));
        this.getComingSoonOfContentById(this.comingSoonContentId);
        this.utility.closeModal('posterUpload');
      })
      .add((_) => {
        this.selectedPosterDef = new PosterDefinition();
        this.posterUrl = null;
        this.fileToUpload = null;
        this.isLoading = false;
      });
  }

  // Poster checker
  posterArrayNumberChecker(contentPosters: ContentPoster): void {
    this.posterNumberArray = [];
    for (const posterId of this.posterNumberArray) {
      if (contentPosters.id != posterId) {
        this.posterNumberArray.push(posterId);
      }
    }
  }

  setDeletePoster(posterDefiniton: PosterDefinition) {
    this.deletablePoster = posterDefiniton;
  }

  deletePoster(posterDefition: PosterDefinition): void {
    this.buttonLoading = true;
    if (this.contentId) {
      this.contentService.removePoster(this.contentId, posterDefition.id).subscribe((_) => {
        $('#modal-deleteposter').modal('hide');
        this.buttonLoading = false;
        this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_DETAIL);
        this.getContentPosters(this.contentId);
        this.getContentById();
      });
    } else if (this.categoryId) {
      this.categoryService.removePoster(this.categoryId, posterDefition.id).subscribe((_) => {
        this.buttonLoading = false;
        this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
        this.getCategoryById(this.categoryId);
      });
    } else if (this.comingSoonContentId) {
      this.comingSoonService.removePoster(this.content.id, posterDefition.id).subscribe((_) => {
        $('#modal-deleteposter').modal('hide');
        this.buttonLoading = false;
        this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_DETAIL);
        //this.store.dispatch(new RefreshActions.RefreshState(true));
        this.getComingSoonOfContentById(this.comingSoonContentId);
      });
    } else if (this.epgProgramId) {
      let poster: ContentPoster;
      this.allPosters.subscribe((data) => {
        poster = data.find((defId) => defId.posterDefinition.id === posterDefition.id);
      });

      // If this is a program poster (not yet uploaded), just remove from the shared IDs
      if (!poster && this.dataSharing.programPosterDefinitionIds.includes(posterDefition.id)) {
        this.dataSharing.programPosterDefinitionIds =
          this.dataSharing.programPosterDefinitionIds.filter((id) => id !== posterDefition.id);
        this.posterNumberArray = this.posterNumberArray.filter((value) => value != posterDefition.id);
        $('#modal-deleteposter').modal('hide');
        this.buttonLoading = false;
        return;
      }

      this.posterService.deletePosterById(poster.id).subscribe((_) => {
        $('#modal-deleteposter').modal('hide');
        this.buttonLoading = false;
        this.posterNumberArray = this.posterNumberArray.filter((value) => value != poster.posterDefinition.id);
        this.store.dispatch(new PosterSetActions.RemoveCatchupPoster(poster.posterDefinition.id));
        // Also remove from program poster IDs if applicable
        this.dataSharing.programPosterDefinitionIds =
          this.dataSharing.programPosterDefinitionIds.filter((id) => id !== posterDefition.id);
        this.refreshManager.sendRefresh(RefreshTarget.VOD_DETAIL);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_DETAIL);
      });
    }
  }

  posterSetter(object: any): string {
    if (this.selectedPoster && this.contentUrlPrefixes.name != 'tempPosterUrl') {
      return  this.selectedPoster.url;
    }
    if (this.selectedPoster && this.contentUrlPrefixes.name == 'tempPosterUrl' && this.contentUrlPrefixes.url == null) {
      return  this.selectedPoster.url;
    }
    if (this.selectedPoster && this.contentUrlPrefixes.name == 'tempPosterUrl') {
      return this.selectedPoster.url;
    }
  }

  private cleanupModalArtifacts() {
    this.renderer.removeClass(document.body, 'modal-open');
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      if (backdrops[0].parentNode) {
        backdrops[0].parentNode.removeChild(backdrops[0]);
      }
    }
  }

  // ============================
  // BANNER CREATION
  // ============================

  onBannerSwitchChange(): void {
    if (!this.bannerSectionOpen) {
      return;
    }
    // Reset form
    this.bannerForm = { name: '', isChild: true };
    this.bannerStartDateStr = '';
    this.bannerEndDateStr = '';
    this.bannerMinDateStr = '';
    this.bannerMaxDateStr = '';
    this.bannerPosterPreview = null;
    this.bannerPosterFile = null;
    this.bannerImageError = '';
    this.bannerError = '';
    this.bannerSuccess = '';
    this.bannerCreating = false;
    this.bannerPosterDefinition = null;

    // Load 500x500 poster definition
    this.bannerService.getAllBannerPosterDefinition().subscribe((defs) => {
      const def500 = defs.find(d => d.width === 500 && d.height === 500);
      this.bannerPosterDefinition = def500 || (defs.length > 0 ? defs[0] : null);
    });

    // Load content plan time range
    if (this.contentId) {
      this.contentService.getContentPlanRange(this.contentId).subscribe(
        (res: number[]) => {
          if (res && res.length >= 2) {
            this.bannerMinDateStr = res[0] ? this.epochToDatetimeLocal(res[0]) : '';
            this.bannerMaxDateStr = res[1] ? this.epochToDatetimeLocal(res[1]) : '';
          }
        },
        () => {}
      );
    }
  }

  handleBannerFileInput(event: any): void {
    this.bannerImageError = '';
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      const image = new Image();
      reader.readAsDataURL(file);
      reader.onload = (e: any) => {
        image.src = e.target.result;
        image.onload = () => {
          if (image.width !== 500 || image.height !== 500) {
            this.bannerImageError = 'Image must be 500x500 pixels. Current: ' + image.width + 'x' + image.height;
            this.bannerPosterFile = null;
            this.bannerPosterPreview = null;
          } else {
            this.bannerPosterFile = file;
            this.bannerPosterPreview = e.target.result;
            this.bannerImageError = '';
          }
        };
      };
    }
  }

  createBanner(): void {
    this.bannerError = '';
    this.bannerSuccess = '';

    // Validation
    if (!this.bannerForm.name || !this.bannerForm.name.trim()) {
      this.bannerError = 'Banner name is required.';
      return;
    }
    if (!this.bannerStartDateStr) {
      this.bannerError = 'Start time is required.';
      return;
    }
    if (!this.bannerEndDateStr) {
      this.bannerError = 'End time is required.';
      return;
    }
    if (!this.bannerPosterFile) {
      this.bannerError = 'Banner image (500x500) is required.';
      return;
    }
    if (!this.bannerPosterDefinition) {
      this.bannerError = 'No 500x500 banner poster definition found.';
      return;
    }

    const startTime = new Date(this.bannerStartDateStr).getTime();
    const endTime = new Date(this.bannerEndDateStr).getTime();

    if (startTime >= endTime) {
      this.bannerError = 'Start time must be before end time.';
      return;
    }

    // Build request
    const req = {
      name: this.bannerForm.name.trim(),
      targetType: 'VOD',
      targetGuid: this.contentId,
      targetName: this.content.name || '',
      status: false,
      isChild: !this.bannerForm.isChild || false,
      sequence: 0,
      startTime: startTime,
      endTime: endTime,
      bannerPosters: []
    };

    const formData = new FormData();
    formData.append('req', JSON.stringify(req));
    formData.append('posterFiles', this.bannerPosterFile, this.bannerPosterFile.name);
    formData.append('posterDefinitionIds', String(this.bannerPosterDefinition.id));

    this.bannerCreating = true;
    this.bannerService.createWithPosters(formData).subscribe(
      (bannerId) => {
        this.bannerCreating = false;
        this.bannerSuccess = 'Banner created successfully! (ID: ' + bannerId + ')';
        this.alertService.success('Banner created successfully!');
      },
      (err) => {
        this.bannerCreating = false;
        const msg = err.error && err.error.message ? err.error.message : 'Failed to create banner.';
        this.bannerError = msg;
      }
    );
  }

  private epochToDatetimeLocal(epoch: number): string {
    const d = new Date(epoch);
    const pad = (n: number) => n < 10 ? '0' + n : '' + n;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
      'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }

}
